import type * as Types from '../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type UpdateEventWebsiteHandleMutationVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  website: Types.Scalars['String'];
}>;

export type UpdateEventWebsiteHandleMutation = { __typename?: 'Mutation'; updateWebsiteHandle: { __typename?: 'Event'; id: string; website: string } };

export const UpdateEventWebsiteHandleDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateEventWebsiteHandle' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'website' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateWebsiteHandle' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'website' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'website' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'website' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateEventWebsiteHandleMutationFn = Apollo.MutationFunction<UpdateEventWebsiteHandleMutation, UpdateEventWebsiteHandleMutationVariables>;

/**
 * __useUpdateEventWebsiteHandleMutation__
 *
 * To run a mutation, you first call `useUpdateEventWebsiteHandleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventWebsiteHandleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventWebsiteHandleMutation, { data, loading, error }] = useUpdateEventWebsiteHandleMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      website: // value for 'website'
 *   },
 * });
 */
export function useUpdateEventWebsiteHandleMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEventWebsiteHandleMutation, UpdateEventWebsiteHandleMutationVariables>,
) {
  return ApolloReactHooks.useMutation<UpdateEventWebsiteHandleMutation, UpdateEventWebsiteHandleMutationVariables>(UpdateEventWebsiteHandleDocument, baseOptions);
}
export type UpdateEventWebsiteHandleMutationHookResult = ReturnType<typeof useUpdateEventWebsiteHandleMutation>;
export type UpdateEventWebsiteHandleMutationResult = Apollo.MutationResult<UpdateEventWebsiteHandleMutation>;
export type UpdateEventWebsiteHandleMutationOptions = Apollo.BaseMutationOptions<UpdateEventWebsiteHandleMutation, UpdateEventWebsiteHandleMutationVariables>;
